import { api } from "../../../utils/api";

export const getTaxInvoiceByPO = async (poId) => {
  return await api.get(`/tax-invoices/po/${poId}`);
};

export const createTaxInvoice = async (data) => {
  return await api.post("/tax-invoices/store", data);
};

export const updateTaxInvoice = async (id, data) => {
  return await api.put(`/tax-invoices/update/${id}`, data);
};

export const getTaxInvoice = async (id) => {
  return await api.get(`/tax-invoices/show/${id}`);
};